var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 9,
    viewBox: "0 0 29 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0103 0.160238L7.21375 8.86415H4.73667L2.86858 1.91704C2.755 1.48974 2.65712 1.33299 2.31154 1.15301C1.74846 0.859244 0.818042 0.584054 0 0.412205L0.0555833 0.160238H4.04308C4.30366 0.159987 4.55574 0.249256 4.75384 0.411932C4.95193 0.574608 5.08298 0.799973 5.12333 1.04735L6.11054 6.08438L8.54896 0.160238H11.0103ZM20.7169 6.02284C20.7265 3.72494 17.4109 3.59837 17.4338 2.57193C17.4411 2.25958 17.7504 1.92749 18.4271 1.84273C19.2201 1.77036 20.0187 1.90515 20.7386 2.23287L21.1495 0.38666C20.4486 0.133468 19.7063 0.00252736 18.9575 0C16.6412 0 15.0111 1.18436 14.9966 2.87847C14.9821 4.13134 16.1603 4.82918 17.0484 5.24719C17.9619 5.67333 18.2688 5.94736 18.264 6.32822C18.2579 6.91343 17.5365 7.17004 16.8623 7.18049C15.6842 7.19791 15.0015 6.87511 14.4553 6.63127L14.0312 8.53787C14.5785 8.77938 15.5887 8.99071 16.6363 9C19.0977 9 20.7084 7.83189 20.7169 6.02284ZM26.8322 8.86415H29L27.109 0.160238H25.108C24.8942 0.158334 24.6847 0.2182 24.5067 0.332073C24.3288 0.445946 24.1905 0.608573 24.1099 0.798865L20.5948 8.86415H23.055L23.5444 7.56367H26.5507L26.8322 8.86415ZM24.2186 5.78016L25.4511 2.51155L26.1616 5.78016H24.2186ZM14.3586 0.160238L12.4217 8.86415H10.0775L12.0169 0.160238H14.3586Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.210368418ca489c924e218018cbf3641.svg";
export { ForwardRef as ReactComponent };